import ADPDeptService from "../../../../services/admin/ADPDeptService";
import ADPParamService from "../../../../services/admin/ADPParamService";
import GEOCtryService from "../../../../services/geo/GEOCtryService";
import GEODistService from "../../../../services/geo/GEODistService";
import GEOPostService from "../../../../services/geo/GEOPostService";
import GEOStateService from "../../../../services/geo/GEOStateService";



class ParameterService {

    async getClientState(): Promise<any> {
        const clientState = localStorage.getItem('clientState');
        return clientState ? JSON.parse(clientState) : null
    }

    async create(data: any): Promise<any> {
        return await ADPParamService.create(data);
    }

    async update(parameterId: any, data: any): Promise<any> {
        return await ADPParamService.update(parameterId, data);
    }

    async findAll(): Promise<any> {
        return await ADPParamService.findAll();
    }

    async getStateDropdown(countryCode: any): Promise<any> {
        return await GEOStateService.getDropdownByCountryCode(countryCode);
    }

    async getCountryDropdown(): Promise<any> {
        return await GEOCtryService.getCountryDropdown();
    }

    async getDistrictDropdown(stateCode: string): Promise<any> {
        return await GEODistService.getDropdownByCountryCodeAndStateCode('MYS',stateCode);
    }

    async getPostcodeDropdown(stateCode: string): Promise<any> {
        return await GEOPostService.getDropdownByStateCode(stateCode);
    }
}

export default new ParameterService();